import React from "react";
import MomentUtils from "@date-io/moment";
import Grid from "@material-ui/core/Grid";
import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";
import { DarkTooltip } from "../material-tooltip";
import {IconButton, Tooltip } from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";
import "./DatePicker.less";

export default function KeyBoardDateTimePickers({
  valueDate = "",
  fullWidth = true,
  label = "Date picker dialog",
  format = "MM/dd/yyyy",
  required = false,
  minDate = "01/01/1700",
  maxDate = "12/31/2050",
  disabled = false,
  tooltipTitle = "",
  toolTip = "",
  handleChange = () => {},
}) {
  /** call on date selection */
  const handleDateChange = (date) => {
    const dd = date ? date.format(format) : "";
    if (dd == "Invalid date") {
      handleChange(dd);
    } else {
      handleChange(dd ? dd : null);
    }
  };

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <DarkTooltip arrow title={tooltipTitle}>
        <Grid justifyContent={"space-around"}>
          <KeyboardDateTimePicker
            fullWidth={fullWidth}
            margin={"normal"}
            className={"DateTimePickerContainer"}
            label={
              <div>
                <span className={"pointer-label"}>{label}</span>
                {required && <span className={"requiredFldText"}>{" *"}</span>}
                {toolTip && (
                  <Tooltip title={toolTip}>
                    <IconButton
                      id={"iconBtn"}
                      size={"small"}
                      className={"tooltip-iconSize"}
                    >
                      <InfoOutlined fontSize={"inherit"} />
                    </IconButton>
                  </Tooltip>
                )}
              </div>
            }
            format={format}
            value={valueDate}
            onChange={handleDateChange}
            minDate={minDate ? minDate : "01/01/1700"}
            maxDate={maxDate ? maxDate : "12/31/2050"}
            // KeyboardButtonProps={{
            // 	"aria-label": "change date"
            // }}
            disabled={disabled}
            clearable
            helperText={""}
          />
        </Grid>
      </DarkTooltip>
    </MuiPickersUtilsProvider>
  );
}
